import React, { Component, type ReactNode } from 'react';
import { Modal as OnboardingDialog } from '@atlaskit/onboarding';
import { Text } from '@atlaskit/primitives';
import { fg } from '@atlassian/jira-feature-gating';
import { injectIntl } from '@atlassian/jira-intl';
import commonMessages from '@atlassian/jira-portfolio-3-portfolio/src/common/view/messages';
import { openInNewTab } from '@atlassian/jira-portfolio-3-portfolio/src/common/window';
import illustration from './illustration.png';
import messages from './messages';
import type { PropsWithIntl as Props } from './types';

// eslint-disable-next-line jira/react/no-class-components
class TwpBenefitsModal extends Component<Props> {
	getOnBoardingDialogActions = () => {
		const {
			intl: { formatMessage },
			setTwpBenefitsModalOpen,
			setTwpBenefitsModalShown,
		} = this.props;

		const actions = [
			{
				onClick: () => {
					setTwpBenefitsModalShown(true);
					setTwpBenefitsModalOpen(false);
				},
				text: formatMessage(commonMessages.close),
			},
		];
		// if LaunchDarkly is unavailable, the url will be an empty string
		// therefore we don't render the "Learn more" button since it would lead to nowhere
		const learnMoreUrl =
			'https://community.atlassian.com/t5/Advanced-Roadmaps-articles/How-to-prepare-teams-with-no-members-for-migration/ba-p/2045801';
		actions.unshift({
			onClick: () => {
				setTwpBenefitsModalShown(true);
				openInNewTab(learnMoreUrl);
			},
			text: formatMessage(commonMessages.learnMore),
		});

		return actions;
	};

	render() {
		const {
			intl: { formatMessage },
			isTwpBenefitsModalOpen,
			useTwpTeams = false,
		} = this.props;

		if (useTwpTeams && isTwpBenefitsModalOpen) {
			return (
				<OnboardingDialog
					actions={this.getOnBoardingDialogActions()}
					heading={formatMessage(messages.title)}
					image={illustration}
				>
					{fg('replace_typography_css_with_tokens_arj') ? (
						<Text as="p">
							{formatMessage(messages.plansContentSpork, {
								strong: (chunks: ReactNode[]) => <Text as="strong">{chunks}</Text>,
							})}
						</Text>
					) : (
						<p>
							{formatMessage(messages.plansContentSpork, {
								// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
								strong: (chunks: ReactNode) => <strong>{chunks}</strong>,
							})}
						</p>
					)}
				</OnboardingDialog>
			);
		}

		return null;
	}
}

export default injectIntl(TwpBenefitsModal);
